import { ListFieldsType, favoriteFiltersListName } from "src/api/config";
import { Filter, FiltersStateType } from "src/pages/DashboardPage/acadia/type";

export function modifiedFavoriteFiltersList(data: ListFieldsType[typeof favoriteFiltersListName][]): Filter[] {
  let resultsObj: Filter[] = [];

  if (data && data.length > 0) {
    resultsObj = data.map((item) => ({
      id: item.ID,
      title: item.Title,
      filter: JSON.parse(item.DocumentsFilter) as FiltersStateType,
    }));
  }

  return resultsObj;
}
